import React, { Component } from "react"
import PropTypes from "prop-types"

import Tag from "../tag"

class FilterTag extends Component {
  onTagClick = () => {
    const { onClick, value } = this.props
    onClick(value)
  }

  render() {
    const { label, className, active } = this.props

    return (
      <Tag
        label={label}
        className={`${className} tag--clickable${
          active ? " tag--selected" : ""
        }`}
        onClick={this.onTagClick}
      />
    )
  }
}

FilterTag.defaultProps = {
  className: "",
  onClick: () => {},
  active: false,
}

FilterTag.propTypes = {
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  value: PropTypes.shape({
    field: PropTypes.string,
    option: PropTypes.string,
  }).isRequired,
  onClick: PropTypes.func,
  active: PropTypes.bool,
}

export default FilterTag
